import React, { useState, useEffect, Fragment, useRef } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";

import LoadingPage from "../../../services/LoadingPage";
import * as _ from "lodash";
import { useLocation } from "react-router-dom";
import { sto } from "../../../Context/InshData";
import { Grid, Typography } from "@material-ui/core";
import { stElemnt } from "../../../St/Reviews/cStyle";
import useFetchURL from "../../../components/Hooks/useFetchURL";
import HeaderConferm from "./HeaderConferm";
import BodyConferm from "./BodyConferm";
import FooterA from "../../Safes/Jard/A4/FooterA";
function OnePage(props) {
    const { found } = props;
    return (
        <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_page }}>

            <Fragment>
                <Grid xs={12} item
                    style={{ maxHeight: "27cm", minHeight: "27cm" }}
                >
                    <HeaderConferm found={found} />
                    <BodyConferm found={found} />
                </Grid>
                <Grid xs={12} item style={{ maxHeight: "2.2cm", minHeight: "2.2cm" }}>
                    <FooterA found={found}
                        isLast={true} />
                </Grid>
            </Fragment>
        </Grid>
    );
}

function AccountConfirmationCon(props) {

    const [found, setFound] = useState({});
    const [loading, setLoading] = useState(true);

    const getInfo = async () => {
        // alert('getInfo')
        const tb = {
            GetFoundation: true,
            wait: true,
            parms: {
                ibranchid: sto.branchi,
                branch: sto.branchi,
                iFoundid: 1,
            },
            autos: {},
        };
        console.log(tb);
        await axios
            .post(`${uri}Res`, tb)
            .then((res) => {
                setFound(res.data.Found);
            })
            .catch((error) => {
                console.log("catch");
            });
    };

    useEffect(() => {
        setTimeout(async () => {
            await getInfo();
            setLoading(false);
            //onUnmountComplete();
        }, 0);
    }, []);

    if (!found || loading) return <LoadingPage />;

    return (
        <Typography component="div" style={stElemnt.AF.Reviws.ReviwsJard}>
            <Typography component="div" >
                <OnePage
                    {...{
                        found,
                    }}
                />
            </Typography>
        </Typography>
    );
}
export default AccountConfirmationCon;
